import React, { useState, useEffect, useMemo, useRef, useCallback, useContext, useImperativeHandle } from 'react';
import classnames from 'classnames';
import { ReactComponent as ConfirmIconDelete } from '@/images/icons/edm/confirm-delete.svg';
import { apis, apiHolder, ProductAuthorityFeature, api, locationHelper, getIn18Text, } from 'api';
import { transContactModel2ContactItem } from '@web-common/components/util/contact';
import { Dropdown, Menu, message, Tooltip } from 'antd';
import LxPopover from '@web-common/components/UI/LxPopover/LxPopover';
import InfoCircleOutlined from '@ant-design/icons/InfoCircleOutlined';
import KeyCode from 'rc-util/lib/KeyCode';
import Selector from '../Selector/selector';
import styles from './mailInfo.module.scss';
import ConferenceBtn from './conference/ConferenceBtn';
import Conference from './conference/Conference';
import PraiseMailBtn from './praiseMail/PraiseMailBtn';
import PraiseMail from './praiseMail/PraiseMail';
import { useAppDispatch, useAppSelector, ContactActions, TempContactActions, MailActions, MailTemplateActions } from '@web-common/state/createStore';
import { actions as mailTabActions } from '@web-common/state/reducer/mailTabReducer';
import { WriteContext } from '@web-setting/Mail/components/CustomTemplate/template_add_modal';
import { extractEmailsFromText, getCopiedContacts } from '../Selector/helper';
import TaskMailBtn from './taskMail/TaskMailBtn';
import TaskMail from './taskMail/TaskMail';
import FollowerCard from './taskMail/FollowerCard';
import debounce from 'lodash/debounce';
import { comIsShowByAuth } from '@web-common/utils/utils';
import IconCard from '@web-common/components/UI/IconCard';
import Attachment from '../Attachment';
import { transMailContactModel2ContactItem } from '@web-common/utils/contact_util';
import { doGetMailContactModelByContactItem } from '@web-common/state/selector/contact';
import { copyText, isSupportPaste, paste } from '@web-common/components/UI/ContextMenu/util';
import SiriusModal from '@web-common/components/UI/Modal/SiriusModal';
import InputContextMenu from '@web-common/components/UI/InputContextMenu/InputContextMenu';
import PersonalOrgModal from '@web-common/components/UI/SiriusContact/personalOrgModal/personalOrg';
import TimeZoneWriteMail from '@web-mail/components/ReadMail/component/TimeZone/TimeZoneWriteMail';
import useDebounceForEvent from '@web-mail/hooks/useDebounceForEvent';
import { systemIsMac } from '@web-mail/util';
import SubjectHelper from './subjectHelper';
import { AiPolishBtn, InsertVariableBtn } from './subjectHelper/btn';
import { EmailContentAssistantComponent } from '@web-edm/send/EmailContentAssistant/assistant';
import { aiModSubject, aiTimesSubtract } from '@web-edm/send/utils/aiModSubject';
import { getSideBarWidth } from '@web-common/utils/constant';
import useCreateCallbackForEvent from '@web-common/hooks/useCreateCallbackForEvent';
import { useGetProductAuth } from '@web-common/hooks/useGetProductAuth';
import { isInvalidSendMailReceiver, getEdmSendConflictConfig, getStoreBooleanData, verifyEmail } from '@web-mail-write/util';
import useState2RM from '@web-mail/hooks/useState2ReduxMock';
const SubjectHelperTips = 'SubjectHelperTipsClosed';
const dataStoreApi = apiHolder.api.getDataStoreApi();
const storeApi = apiHolder.api.getDataStoreApi();
const trackApi = apiHolder.api.requireLogicalApi(apis.dataTrackerApiImp);
const contactApi = api.requireLogicalApi(apis.contactApiImpl);
const mailApi = apiHolder.api.requireLogicalApi(apis.mailApiImpl);
const mailPlusCustomerApi = api.requireLogicalApi(apis.mailPlusCustomerApiImpl);
const checkEmails = (receivers) => receivers === null || receivers === void 0 ? void 0 : receivers.some(receiver => { var _a, _b, _c; return ((_a = receiver === null || receiver === void 0 ? void 0 : receiver.contactItem) === null || _a === void 0 ? void 0 : _a.contactItemType) === 'EMAIL' && !verifyEmail((_c = (_b = receiver === null || receiver === void 0 ? void 0 : receiver.contactItem) === null || _b === void 0 ? void 0 : _b.contactItemVal) === null || _c === void 0 ? void 0 : _c.trim()); });
const systemApi = api.getSystemApi();
const isMac = systemIsMac();
const MailInfo = React.forwardRef((props, ref) => {
    const { dyncGroupSendReset, pasteAtt } = props;
    const { productVersionInfo: { navigateVersion, productVersionId }, } = useGetProductAuth();
    const { isMailTemplate } = useContext(WriteContext);
    const [showWriteContact, setShowWriteContact] = useState(true);
    const [totalReceivers, setTotalReceivers] = useState([]);
    const [keywordSender, setKeywordSender] = useState('');
    const [keywordCC, setKeywordCC] = useState('');
    const [keywordBCC, setKeywordBCC] = useState('');
    const attachments = useAppSelector(state => state.attachmentReducer.attachments);
    const isCorpMail = useAppSelector(state => state.loginReducer.loginInfo.isCorpMailMode);
    const mailLength = useAppSelector(state => state.mailReducer.mails.length);
    const isOneRcpt = useAppSelector(state => state.mailReducer.currentMail.isOneRcpt);
    const isDyncGroupSend = useAppSelector(state => state.mailReducer.currentMail.isDyncGroupSend);
    const isCommonOrEditDraft = useAppSelector(state => { var _a, _b; return ['common', 'edit', 'editDraft'].includes(((_b = (_a = state.mailReducer.currentMail) === null || _a === void 0 ? void 0 : _a.entry) === null || _b === void 0 ? void 0 : _b.writeLetterProp) || ''); });
    const [edmShowContactDetail, setEdmShowContactDetail] = useState2RM('edmShowContactDetail');
    const attPasteable = useAppSelector(state => state.mailReducer.attPasteable);
    useEffect(() => {
        if (mailLength > 0 && isOneRcpt && !isCommonOrEditDraft) {
            changeOneRcptStatus();
        }
    }, [mailLength]);
    const mailInfoWrapper = useRef(null);
    const focused = useAppSelector(state => (isMailTemplate ? state.tempContactReducer.selector.focused : state.contactReducer.selector.focused));
    const dispatch = useAppDispatch();
    const subject = useAppSelector(state => { var _a, _b, _c, _d; return isMailTemplate ? (_b = (_a = state.mailTemplateReducer.mailTemplateContent) === null || _a === void 0 ? void 0 : _a.entry) === null || _b === void 0 ? void 0 : _b.title : (_d = (_c = state.mailReducer.currentMail) === null || _c === void 0 ? void 0 : _c.entry) === null || _d === void 0 ? void 0 : _d.title; });
    const [subjectTemp, setSubjectTemp] = useState(subject);
    const mailTemplateName = useAppSelector(state => state.mailTemplateReducer.mailTemplateName);
    const receivers = useAppSelector(state => { var _a, _b; return isMailTemplate ? (_a = state.mailTemplateReducer.mailTemplateContent) === null || _a === void 0 ? void 0 : _a.receiver : (_b = state.mailReducer.currentMail) === null || _b === void 0 ? void 0 : _b.receiver; });
    const { normalReceivers, ccReceivers, bccReceivers, hasWrongNormal, hasWrongCc, hasWrongBcc, sendMailConflictConfig } = useAppSelector(state => {
        var _a, _b;
        const list = (isMailTemplate ? (_a = state.mailTemplateReducer.mailTemplateContent) === null || _a === void 0 ? void 0 : _a.receiver : (_b = state.mailReducer.currentMail) === null || _b === void 0 ? void 0 : _b.receiver) || [];
        const normalReceivers = list.filter(receiver => receiver.mailMemberType === 'to');
        const ccReceivers = list.filter(receiver => receiver.mailMemberType === 'cc');
        const bccReceivers = list.filter(receiver => receiver.mailMemberType === 'bcc');
        let hasWrongNormal = checkEmails(normalReceivers);
        let hasWrongCc = checkEmails(ccReceivers);
        let hasWrongBcc = checkEmails(bccReceivers);
        if (!process.env.BUILD_ISEDM) {
            return {
                normalReceivers,
                ccReceivers,
                bccReceivers,
                hasWrongNormal,
                hasWrongCc,
                hasWrongBcc,
            };
        }
        const { contactMap, emailIdMap } = state.contactReducer;
        const options = getEdmSendConflictConfig();
        hasWrongNormal =
            hasWrongNormal ||
                isInvalidSendMailReceiver({
                    receivers: normalReceivers,
                    emailIdMap,
                    contactMap,
                    options,
                });
        hasWrongCc =
            hasWrongCc ||
                isInvalidSendMailReceiver({
                    receivers: ccReceivers,
                    emailIdMap,
                    contactMap,
                    options,
                });
        hasWrongBcc =
            hasWrongBcc ||
                isInvalidSendMailReceiver({
                    receivers: bccReceivers,
                    emailIdMap,
                    contactMap,
                    options,
                });
        return {
            normalReceivers,
            ccReceivers,
            bccReceivers,
            hasWrongNormal,
            hasWrongCc,
            hasWrongBcc,
            sendMailConflictConfig: options,
        };
    });
    const infoStatus = useAppSelector(state => { var _a, _b; return (isMailTemplate ? (_a = state.mailTemplateReducer.mailTemplateContent) === null || _a === void 0 ? void 0 : _a.status : (_b = state.mailReducer.currentMail) === null || _b === void 0 ? void 0 : _b.status); });
    const focusTitleStatus = useAppSelector(state => { var _a, _b; return isMailTemplate ? (_a = state.mailTemplateReducer.mailTemplateContent) === null || _a === void 0 ? void 0 : _a.focusTitle : (_b = state.mailReducer.currentMail) === null || _b === void 0 ? void 0 : _b.focusTitle; });
    const selectedTags = useAppSelector(state => (isMailTemplate ? state.tempContactReducer.selectedTags : state.contactReducer.selectedTags));
    const writeLetterProp = useAppSelector(state => { var _a, _b; return (_b = (_a = state.mailReducer) === null || _a === void 0 ? void 0 : _a.currentMail) === null || _b === void 0 ? void 0 : _b.writeLetterProp; });
    const currentTab = useAppSelector(state => state.mailTabReducer.currentTab);
    const currentTabRef = useRef(currentTab);
    currentTabRef.current = currentTab;
    const currentMail = useAppSelector(state => state.mailReducer.currentMail);
    const currentMailRef = useRef(currentMail);
    currentMailRef.current = currentMail;
    const sendSelectorRef = useRef(null);
    const ccSelectorRef = useRef(null);
    const bccSelectorRef = useRef(null);
    const refSubject = useRef(null);
    const aiPolishBtnRef = useRef(null);
    const conferenceShow = infoStatus === null || infoStatus === void 0 ? void 0 : infoStatus.conferenceShow;
    const praiseMailShow = infoStatus === null || infoStatus === void 0 ? void 0 : infoStatus.praiseMailShow;
    const taskShow = infoStatus === null || infoStatus === void 0 ? void 0 : infoStatus.taskMailShow;
    const showCc = infoStatus === null || infoStatus === void 0 ? void 0 : infoStatus.cc;
    const showBcc = infoStatus === null || infoStatus === void 0 ? void 0 : infoStatus.bcc;
    const onActions = isMailTemplate ? MailTemplateActions : MailActions;
    const { doModifyReceiver, doReplaceReceiver, doFocusTitle, doModifySubject, doShowWriteContact, doCCShow, doBCCShow } = onActions;
    const onContactActions = isMailTemplate ? TempContactActions : ContactActions;
    const { doSelectTags, doFocusSelector } = onContactActions;
    const [attachmentsCount, setAttachmentsCount] = useState(0);
    const [attachmentFlod, setAttachmentFlod] = useState(false);
    const [attachmentsHeight, setAttachmentsHeight] = useState(0);
    const [defaultPersonalOrgSelect, setDefaultPersonalOrgSelect] = useState([]);
    const [personalOrgModalVisible, setPersonalOrgModalVisible] = useState(false);
    const [subjectHelperTipsClosed, setSubjectHelperTipsClosed] = useState(getStoreBooleanData(SubjectHelperTips));
    const [subjectStyle, setSubjectStyle] = useState({});
    const [visibleSubjectHelper, setVisibleSubjectHelper] = useState(false);
    const [subjectHelperPos, setSubjectHelperPos] = useState({});
    const [subjectLoading, setSubjectLoading] = useState(false);
    const [subjectHelperVisible, setSubjectHelperVisible] = useState(false);
    const attachmentsRef = useRef(null);
    const attachmentAreaRef = useRef(null);
    const setEncrypt = useMemo(() => {
        return (currentMail === null || currentMail === void 0 ? void 0 : currentMail.setEncrypt) || false;
    }, [currentMail]);
    const isThirdAccount = useMemo(() => {
        var _a, _b;
        const accountData = currentMail === null || currentMail === void 0 ? void 0 : currentMail.optSender;
        if (!accountData) {
            return false;
        }
        if (accountData.isMainAccount) {
            return ((_b = (_a = systemApi.getCurrentUser()) === null || _a === void 0 ? void 0 : _a.prop) === null || _b === void 0 ? void 0 : _b.authAccountType) !== '0';
        }
        return !!accountData.isThirdAccount;
    }, [currentMail === null || currentMail === void 0 ? void 0 : currentMail.optSender]);
    const isSubAccount = useMemo(() => {
        try {
            const accountData = currentMail === null || currentMail === void 0 ? void 0 : currentMail.optSender;
            if (accountData === null || accountData === void 0 ? void 0 : accountData.isSubAccount)
                return true;
            return false;
        }
        catch (error) {
            return false;
        }
    }, [currentMail === null || currentMail === void 0 ? void 0 : currentMail.optSender]);
    useEffect(() => {
        if (isThirdAccount && isOneRcpt) {
            changeOneRcptStatus();
            message.error(getIn18Text('FEIWANGYIQYYXWFSYQFD3'));
        }
    }, [isThirdAccount, isOneRcpt]);
    const handleTotalReceivers = (needSort) => {
        let totalReceivers = receivers;
        if (needSort) {
            const normalReceivers = receivers.filter(receiver => receiver.mailMemberType === 'to');
            const ccReceivers = receivers.filter(receiver => receiver.mailMemberType === 'cc');
            const bccReceivers = receivers.filter(receiver => receiver.mailMemberType === 'bcc');
            totalReceivers = [...normalReceivers, ...ccReceivers, ...bccReceivers];
        }
        setTotalReceivers(totalReceivers);
    };
    useEffect(() => {
        setAttachmentsCount(attachments.filter(i => i.mailId === currentMail.cid && !i.forwardWithout).length);
    }, [attachments, currentMail.cid]);
    useEffect(() => {
        isOneRcpt && handleTotalReceivers();
    }, [receivers === null || receivers === void 0 ? void 0 : receivers.length]);
    useEffect(() => {
        isOneRcpt && handleTotalReceivers(true);
    }, [isOneRcpt]);
    useEffect(() => {
        if (infoStatus) {
            const { showContact } = infoStatus;
            setShowWriteContact(showContact);
        }
    }, [infoStatus]);
    useEffect(() => {
        const targetEle = attachmentsRef.current;
        if (!targetEle)
            return;
        const resizeOb = new ResizeObserver(entries => {
            for (const entry of entries) {
                setAttachmentsHeight(entry.target.scrollHeight);
            }
        });
        resizeOb.observe(targetEle);
        return () => {
            resizeOb.disconnect();
        };
    }, []);
    useEffect(() => {
        setAttachmentFlod(false);
    }, [attachmentsCount]);
    const setShowCc = (status) => {
        dispatch(doCCShow(status));
    };
    const setShowBcc = (status) => {
        dispatch(doBCCShow(status));
    };
    const handleDrag = (e) => {
        e.preventDefault();
        e.stopPropagation();
    };
    useEffect(() => {
        if (mailInfoWrapper.current) {
            mailInfoWrapper === null || mailInfoWrapper === void 0 ? void 0 : mailInfoWrapper.current.addEventListener('dragenter', handleDrag);
        }
        return () => {
            var _a;
            (_a = mailInfoWrapper === null || mailInfoWrapper === void 0 ? void 0 : mailInfoWrapper.current) === null || _a === void 0 ? void 0 : _a.removeEventListener('dragenter', handleDrag);
        };
    }, [mailInfoWrapper]);
    useEffect(() => {
        const ccReceivers = receivers === null || receivers === void 0 ? void 0 : receivers.filter(receiver => receiver.mailMemberType === 'cc');
        const bccReceivers = receivers === null || receivers === void 0 ? void 0 : receivers.filter(receiver => receiver.mailMemberType === 'bcc');
        if (ccReceivers === null || ccReceivers === void 0 ? void 0 : ccReceivers.length)
            setShowCc(true);
        if (bccReceivers === null || bccReceivers === void 0 ? void 0 : bccReceivers.length)
            setShowBcc(true);
        if (focused === '正文') {
            setAttachmentFlod(true);
        }
    }, [receivers, focused]);
    const focusSelector = {
        to: (keyword) => {
            var _a;
            (_a = sendSelectorRef === null || sendSelectorRef === void 0 ? void 0 : sendSelectorRef.current) === null || _a === void 0 ? void 0 : _a.focus();
            keyword && setKeywordSender(keyword);
        },
        cc: (keyword) => {
            var _a;
            (_a = ccSelectorRef === null || ccSelectorRef === void 0 ? void 0 : ccSelectorRef.current) === null || _a === void 0 ? void 0 : _a.focus();
            keyword && setKeywordCC(keyword);
        },
        bcc: (keyword) => {
            var _a;
            (_a = bccSelectorRef === null || bccSelectorRef === void 0 ? void 0 : bccSelectorRef.current) === null || _a === void 0 ? void 0 : _a.focus();
            keyword && setKeywordBCC(keyword);
        },
    };
    useEffect(() => {
        if (focused === 'focusto') {
            setTimeout(() => {
                var _a;
                (_a = sendSelectorRef === null || sendSelectorRef === void 0 ? void 0 : sendSelectorRef.current) === null || _a === void 0 ? void 0 : _a.focus();
            }, 1000);
        }
    }, [focused, currentMail.cid]);
    useImperativeHandle(ref, () => ({
        insertSubject: (key, value) => {
            const input = refSubject.current;
            const oldVal = subjectTemp || '';
            let variable = value;
            if (['%E6%98%B5%E7%A7%B0', '%E5%A7%93%E5%90%8D', '%E5%85%AC%E5%8F%B8%E5%90%8D%E7%A7%B0'].includes(encodeURI(variable)) && key) {
                let keyLast = key.slice(-1);
                if (!Number.isInteger(+keyLast)) {
                    keyLast = 0;
                }
                variable += keyLast;
            }
            const insertContent = `[${variable}]`;
            let newVal = oldVal + insertContent;
            if (input && oldVal) {
                let start = input.selectionStart || 0;
                let end = input.selectionEnd || 0;
                newVal = oldVal.substring(0, start) + insertContent + oldVal.substring(end);
            }
            onSubjectChange({
                target: {
                    value: newVal,
                },
            });
        },
    }));
    const onTagsPatse = async () => {
        const { emails, type } = selectedTags;
        if (emails.length === 1) {
            const clipboardData = await paste(false);
            if (!clipboardData)
                return;
            const extractEmails = extractEmailsFromText(clipboardData);
            const result = await contactApi.doGetContactByEmails(extractEmails, type);
            const target = result.map(transMailContactModel2ContactItem);
            const contactItemList = receivers.filter(_ => _.mailMemberType === type).map(transMailContactModel2ContactItem);
            const index = contactItemList.findIndex(c => emails.includes(c.email));
            if (index !== -1) {
                contactItemList.splice(index, 1, ...target);
            }
            const receiver = await doGetMailContactModelByContactItem(contactItemList, type);
            dispatch(doModifyReceiver({
                receiver,
                receiverType: type,
            }));
        }
    };
    const handleCutAndCopy = async (e) => {
        var _a;
        if (!e.target || e.target.getAttribute('data-test-id') == 'contact_selectList_search_input') {
            return;
        }
        e.preventDefault();
        const { emails, type } = selectedTags;
        const { which, metaKey, ctrlKey, key } = e;
        if ([KeyCode.DELETE, KeyCode.BACKSPACE].includes(which)) {
            dispatch(doModifyReceiver({ receiver: emails, receiverType: type, operation: 'delete' }));
            dispatch(doSelectTags({ emails: [], type }));
            focusSelector[focused] && focusSelector[focused]();
        }
        const holdingCtrl = metaKey || ctrlKey;
        const copiedContacts = getCopiedContacts(receivers, type, emails);
        if ([KeyCode.X, KeyCode.C].includes(which) && holdingCtrl) {
            if (!(await isSupportPaste())) {
                SiriusModal.error({
                    content: '浏览器版本过低，不支持联系人的复制/剪切，请升级到新版chrome浏览器使用',
                    okText: getIn18Text('ZHIDAOLE'),
                    hideCancel: true,
                });
                return;
            }
            if (which === KeyCode.X) {
                copyText(copiedContacts);
                dispatch(doModifyReceiver({ receiver: emails, receiverType: type, operation: 'delete' }));
            }
            else if (which === KeyCode.C) {
                copyText(copiedContacts);
            }
        }
        if (which === KeyCode.V && holdingCtrl && (await isSupportPaste())) {
            onTagsPatse();
        }
        if (which === KeyCode.A && holdingCtrl) {
            if (selectedTags.emails.length > 0) {
                dispatch(doSelectTags({
                    emails: receivers.filter(item => item.mailMemberType === selectedTags.type).map(item => contactApi.doGetModelDisplayEmail(item.contact)),
                    type: selectedTags.type,
                }));
            }
        }
        if (((_a = selectedTags.emails) === null || _a === void 0 ? void 0 : _a.length) > 0 && !holdingCtrl && /^[a-z0-9]$/i.test(key)) {
            dispatch(doModifyReceiver({ receiver: selectedTags.emails, receiverType: selectedTags.type, operation: 'delete' }));
            dispatch(doSelectTags({ emails: [], type: selectedTags.type }));
            focusSelector[selectedTags.type] && focusSelector[selectedTags.type](key);
        }
    };
    useEffect(() => {
        if (!selectedTags.emails.length) {
            return;
        }
        document.addEventListener('keydown', handleCutAndCopy);
        return () => {
            document.removeEventListener('keydown', handleCutAndCopy);
        };
    }, [selectedTags, handleCutAndCopy]);
    useEffect(() => {
        var _a;
        if (focusTitleStatus) {
            (_a = refSubject.current) === null || _a === void 0 ? void 0 : _a.focus();
            dispatch(doFocusTitle(false));
        }
    }, [focusTitleStatus]);
    useEffect(() => {
        if (attachmentFlod) {
            if (attachmentAreaRef === null || attachmentAreaRef === void 0 ? void 0 : attachmentAreaRef.current) {
                attachmentAreaRef.current.scrollTop = 0;
            }
        }
    }, [attachmentFlod]);
    useEffect(() => {
        mailPlusCustomerApi.doGetEdmSendMailConflictConfigForce();
    }, []);
    const modifyTabTitle = debounce((subject) => {
        locationHelper.isMainPage() &&
            currentTabRef.current.id === String(currentMail.cid) &&
            dispatch(mailTabActions.doChangeTabById({
                id: currentTabRef.current.id,
                tabModel: Object.assign(Object.assign({}, currentTabRef.current), { title: subject || getIn18Text('WUZHUTI') }),
            }));
    }, 100);
    const modSubject = debounce(newSubject => {
        dispatch(doModifySubject(newSubject));
    }, 200);
    const onSubjectChange = useCallback(e => {
        const newSubject = e.target.value;
        setSubjectTemp(newSubject);
        modSubject(newSubject);
    }, []);
    useEffect(() => {
        setSubjectTemp(subject);
        modifyTabTitle(subject);
    }, [subject]);
    const onTemplateNameChange = useCallback(e => {
        let templateName = e.target.value;
        if (templateName.length > 50) {
            message.destroy();
            message.error({
                content: getIn18Text('QINGSHURU50'),
            });
            templateName = templateName.slice(0, 50);
        }
        dispatch(MailTemplateActions.doModifyTemplateName(templateName));
    }, []);
    const changeCcStatus = (status) => {
        setShowCc(status);
        if (status) {
            storeApi.put('ccStatus', 'open');
            setTimeout(() => {
                var _a;
                (_a = ccSelectorRef.current) === null || _a === void 0 ? void 0 : _a.focus();
            }, 100);
        }
    };
    const closeCC = () => {
        setShowCc(false);
        dispatch(doReplaceReceiver(receivers.filter(r => r.mailMemberType !== 'cc')));
        storeApi.put('ccStatus', 'close');
    };
    const closeBCC = () => {
        setShowBcc(false);
        dispatch(doReplaceReceiver(receivers.filter(r => r.mailMemberType !== 'bcc')));
        storeApi.put('bccStatus', 'close');
    };
    const changeBccStatus = (status) => {
        setShowBcc(status);
        if (status) {
            storeApi.put('bccStatus', 'open');
            setTimeout(() => {
                var _a;
                (_a = bccSelectorRef.current) === null || _a === void 0 ? void 0 : _a.focus();
            }, 100);
        }
    };
    const changeOneRcptStatus = () => {
        dispatch(MailActions.doChangeMailOneRcpt(!isOneRcpt));
    };
    const toggleShowContact = () => {
        if ((process.env.BUILD_ISEDM || process.env.BUILD_ISLINGHANG) && edmShowContactDetail) {
            setEdmShowContactDetail(false);
        }
        else {
            const show = !showWriteContact;
            trackApi.track('pcMail_click_AddressButton', { status: show ? getIn18Text('ZHANKAI') : getIn18Text('SHOUQI') });
            dispatch(doShowWriteContact(show));
            dataStoreApi.put('showContact', show).then(() => { });
        }
    };
    const getPersonCount = (receiver, wrapperRef, to = false) => {
        var _a;
        const height = ((_a = wrapperRef === null || wrapperRef === void 0 ? void 0 : wrapperRef.current) === null || _a === void 0 ? void 0 : _a.wrapperHeight) || 44;
        return (receiver.length > 10 && (React.createElement("span", { className: classnames(styles.memberCount, {
                [styles.memberCountLittle]: to && (isOneRcpt ? totalReceivers.length < 16 : normalReceivers.length < 16),
            }) },
            getIn18Text('GONG'), receiver === null || receiver === void 0 ? void 0 :
            receiver.length,
            getIn18Text('REN&nbs'),
            "\u00A0")));
    };
    const onClickAiPolish = useCreateCallbackForEvent(async () => {
        if (subjectLoading) {
            return;
        }
        if (!subject || !subject.trim()) {
            message.error(getIn18Text('QINGSHURUZHUTINR'));
            return;
        }
        setSubjectLoading(true);
        try {
            const res = await aiModSubject([subject], 1, 5);
            message.success(getIn18Text('AIRUNSEWANC，ZTYTH'));
            setSubjectTemp(res[0]);
            modSubject(res[0]);
            aiTimesSubtract();
        }
        catch (error) {
            let err = (error === null || error === void 0 ? void 0 : error.message) || error;
            if (err === '今日剩余次数不足') {
                err = getIn18Text('JINRIAIKEYCSW0');
            }
            message.error(err);
        }
        finally {
            setSubjectLoading(false);
        }
    });
    const NewPersonalGroup = ({ items }) => {
        const toggleNewPersonalGroup = async () => {
            const emails = items.map(item => { var _a; return (_a = item.contactItem) === null || _a === void 0 ? void 0 : _a.contactItemVal; });
            const contactRes = await contactApi.doGetContactByEmailFilter({ emails });
            const contactResKeys = Object.keys(contactRes);
            const diff = emails.filter(item => !contactResKeys.includes(item));
            const itemsInContact = items.filter(item => { var _a; return !diff.includes((_a = item.contactItem) === null || _a === void 0 ? void 0 : _a.contactItemVal); });
            let res = itemsInContact.map(item => transContactModel2ContactItem(item.contact));
            if (diff.length > 0) {
                SiriusModal.error({
                    title: '联系人中有陌生邮箱地址，需要添加个人通讯录再创建分组。是否添加？',
                    cancelText: '跳过',
                    okText: '添加',
                    onOk: async () => {
                        const enterpriseList = [];
                        diff.forEach(item => {
                            const name = item.split('@')[0] || '未知';
                            enterpriseList.push({
                                name,
                                emailList: [item],
                                groupIdList: [],
                            });
                        });
                        const { success, data: insertPersonalList } = await contactApi.doInsertContact({
                            list: enterpriseList,
                        });
                        if (success && insertPersonalList) {
                            res = res.concat(transContactModel2ContactItem(insertPersonalList[0]));
                            setDefaultPersonalOrgSelect(res);
                            setPersonalOrgModalVisible(true);
                        }
                    },
                    onCancel: () => {
                        setDefaultPersonalOrgSelect(res);
                        setPersonalOrgModalVisible(true);
                    },
                });
            }
            else {
                setDefaultPersonalOrgSelect(res);
                setPersonalOrgModalVisible(true);
            }
        };
        return (React.createElement(React.Fragment, null,
            React.createElement("span", { className: classnames([styles.labelBtn, styles.newPersonalGroup]), onClick: toggleNewPersonalGroup }, getIn18Text('XINJIANGERENFEN')),
            React.createElement("span", { className: styles.labelDivider }, '|')));
    };
    const clickDelAllTo = (type) => {
        const typeMap = { to: '收件人', cc: '抄送人', bcc: '密送人' };
        SiriusModal.confirm({
            title: `确认清空全部${typeMap[type]}吗？`,
            icon: React.createElement(ConfirmIconDelete, null),
            okType: 'danger',
            className: styles.delAllTo,
            centered: true,
            closable: true,
            content: '',
            okText: '确定',
            cancelText: '取消',
            zIndex: 1010,
            onOk() {
                dispatch(doReplaceReceiver(receivers.filter(r => r.mailMemberType !== type)));
            },
        });
    };
    const toReceivers = isOneRcpt ? totalReceivers : normalReceivers;
    const confQuit = () => {
        dispatch(MailActions.doChangeDyncGroupSend(false));
        dispatch(MailActions.doClearDyncGroupSendStatus(null));
        dispatch(MailActions.doModifySubject(''));
        dispatch(MailActions.doModifyReceiver({ receiver: [], receiverType: 'to' }));
        dyncGroupSendReset && dyncGroupSendReset();
    };
    const quitDynGroupGroupSend = () => {
        SiriusModal.confirm({
            className: 'clientConfirm',
            title: getIn18Text('QUERENTUICM'),
            content: getIn18Text('TUICHUDONGTQFHJWFZYJ30'),
            cancelText: getIn18Text('setting_system_switch_cancel'),
            okText: getIn18Text('QUEDING'),
            centered: true,
            onOk: () => confQuit(),
        });
    };
    const openDynGroupGroupSend = () => {
        if (productVersionId === 'free') {
            message.warn(getIn18Text('MIANFEIBANWFSYCGNQLX12'));
            return;
        }
        dispatch(MailActions.doChangeDyncGroupSendStatus({ showModal: true }));
    };
    const attMenu = useMemo(() => {
        if (attPasteable) {
            return (React.createElement(Menu, null,
                React.createElement(Menu.Item, { key: "1", onClick: pasteAtt }, getIn18Text('NIANTIEFUJ'))));
        }
        return React.createElement(React.Fragment, null);
    }, [attPasteable]);
    const btnBox = (React.createElement("div", { className: classnames(styles.btnBox, { [styles.btnBoxMultLine]: toReceivers.length > 15 }), tabIndex: -1 },
        getPersonCount(toReceivers, sendSelectorRef, true),
        toReceivers.length > 1 && (React.createElement("span", { className: classnames([styles.labelBtn]), onClick: () => {
                clickDelAllTo('to');
            } }, "\u5220\u9664")),
        toReceivers.length > 1 && !isDyncGroupSend && React.createElement(NewPersonalGroup, { items: toReceivers }),
        isCorpMail || conferenceShow || taskShow || praiseMailShow || isMailTemplate || isOneRcpt || isThirdAccount || isSubAccount ? null : (React.createElement("span", { "data-test-id": "mailinfo-btn-dyn-group-send", className: classnames(styles.labelBtn), onClick: () => {
                if (!isDyncGroupSend) {
                    openDynGroupGroupSend();
                }
                else {
                    quitDynGroupGroupSend();
                }
            } }, isDyncGroupSend ? getIn18Text('TUICHUDONGTQF') : getIn18Text('DONGTAIQUNF'))),
        !showCc && !isOneRcpt && !isDyncGroupSend && (React.createElement("span", { "data-test-id": "mailinfo-btn-cc", className: classnames([styles.labelBtn], {
                [styles.labelBtnSelected]: showCc,
            }), onClick: () => {
                changeCcStatus(true);
                dispatch(doFocusSelector(''));
            } }, getIn18Text('CHAOSONG'))),
        !showBcc && !taskShow && !isOneRcpt && !isDyncGroupSend && (React.createElement("span", { "data-test-id": "mailinfo-btn-bcc", className: classnames([styles.labelBtn], {
                [styles.labelBtnSelected]: showBcc,
            }), onClick: () => {
                changeBccStatus(true);
                dispatch(doFocusSelector(''));
            } }, getIn18Text('MISONG'))),
        isCorpMail || conferenceShow || taskShow || praiseMailShow || isMailTemplate || isDyncGroupSend || isThirdAccount ? null : (React.createElement("span", { "data-test-id": "mailinfo-btn-onercpt", className: classnames(styles.labelBtn), onClick: () => {
                changeOneRcptStatus();
                dispatch(doFocusSelector(''));
            } }, isOneRcpt ? getIn18Text('QUXIAOQUNFADAN') : getIn18Text('QUNFADANXIAN'))),
        (!showCc && !isOneRcpt) || (!showBcc && !taskShow && !isOneRcpt) || !(isCorpMail || conferenceShow || taskShow || praiseMailShow || isMailTemplate) ? (React.createElement("span", { className: styles.labelDivider }, '|')) : (React.createElement(React.Fragment, null)),
        React.createElement("span", { className: classnames([styles.labelBtn, styles.iconLabelBtn], {
                [styles.labelBtnSelected]: showWriteContact && !edmShowContactDetail,
            }), "data-test-id": "mailinfo-btn-contact", onClick: toggleShowContact },
            React.createElement(IconCard, { type: showWriteContact ? 'contact_left' : 'contact_right' }),
            getIn18Text('TONGXUNLU'))));
    const debounceSendMail = useDebounceForEvent(() => {
        eventApi.sendSysEvent({
            eventName: 'mailMenuOper',
            eventData: {},
            eventStrData: 'sendMail',
        });
    }, 1000, {
        leading: true,
        trailing: false,
    });
    const debounceSaveDraft = useDebounceForEvent(() => {
        eventApi.sendSysEvent({
            eventName: 'mailMenuOper',
            eventData: {},
            eventStrData: 'saveDraft',
        });
    }, 1000, {
        leading: true,
        trailing: false,
    });
    const renderSubjectContent = () => {
        return (React.createElement("div", { "data-test-id": "write-subject" },
            React.createElement(InputContextMenu, { inputOutRef: refSubject, changeVal: setSubjectTemp },
                React.createElement("input", { className: classnames(styles.inputItem, {
                        [styles.titleInput]: !conferenceShow,
                        [styles.disabled]: subjectLoading,
                    }), tabIndex: 34, maxLength: 256, value: subjectTemp, disabled: subjectLoading, ref: refSubject, onClick: () => {
                        var _a, _b;
                        if (!subjectHelperTipsClosed) {
                            const pos = (_a = refSubject.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
                            const mailInfoPos = (_b = mailInfoWrapper.current) === null || _b === void 0 ? void 0 : _b.getBoundingClientRect();
                            if (mailInfoPos && pos) {
                                setVisibleSubjectHelper(true);
                                setSubjectHelperPos(pos || null);
                                setSubjectStyle({
                                    width: mailInfoPos.width - pos.left + getSideBarWidth() - 16,
                                });
                            }
                        }
                    }, onFocus: () => {
                        dispatch(doFocusSelector(getIn18Text('ZHUTI')));
                    }, onChange: onSubjectChange, onKeyDown: event => {
                        if ((isMac && event.metaKey && event.key === 'Enter') || (!isMac && event.ctrlKey && event.key === 'Enter')) {
                            event.preventDefault();
                            debounceSendMail();
                        }
                        else if ((isMac && event.metaKey && event.key === 's') || (!isMac && event.ctrlKey && event.key === 's')) {
                            event.preventDefault();
                            debounceSaveDraft();
                        }
                    } }))));
    };
    const visibleTaskOrPraise = !process.env.BUILD_ISEDM &&
        !(process.env.BUILD_ISEDM || navigateVersion) &&
        !isCorpMail &&
        !isOneRcpt &&
        !isMailTemplate &&
        !setEncrypt &&
        !taskShow &&
        !conferenceShow &&
        !praiseMailShow;
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: styles.writeMailInfo, tabIndex: -1, id: "writeMailInfo", ref: mailInfoWrapper },
            React.createElement("div", { className: styles.infoItem, hidden: !isMailTemplate },
                React.createElement("span", { className: styles.infoLabel }, getIn18Text('MOBANMINGCHENG')),
                React.createElement("span", { className: styles.colonLabel }, ":"),
                React.createElement("div", { className: `ant-allow-dark ${styles.titleDesc}` },
                    React.createElement("input", { className: classnames(styles.inputItem, { [styles.titleInput]: !conferenceShow }), value: mailTemplateName, onChange: onTemplateNameChange }))),
            React.createElement("div", { className: classnames([styles.infoItem, styles.webkitNoDrag], {
                    [styles.infoItemWarning]: hasWrongNormal,
                    [styles.flowColumn]: isOneRcpt ? totalReceivers.length > 2 : normalReceivers.length > 2,
                    [styles.dyncGroupSendReceiver]: isDyncGroupSend,
                }) },
                React.createElement("div", { "data-test-id": "mailinfo-selector-to", className: classnames([styles.receiverWrapper]) },
                    isOneRcpt ? (React.createElement("span", { className: classnames([styles.infoLabel, styles.infoLabelSingle]) },
                        getIn18Text('QUNFADANXIAN'),
                        React.createElement(Tooltip, { arrowPointAtCenter: true, destroyTooltipOnHide: true, placement: "bottomLeft", overlayClassName: "rencent-tooltip-arrow", title: getIn18Text('\u201CQUNFADANXIAN'), overlayStyle: { maxWidth: '100%' } },
                            React.createElement(InfoCircleOutlined, null)))) : (React.createElement("span", { className: classnames(styles.infoLabel, { [styles.executeLabel]: taskShow }) }, taskShow ? getIn18Text('SHOUJIAN\uFF08ZHIXING') : getIn18Text('SHOUJIANREN1'))),
                    React.createElement("span", { className: styles.colonLabel }, ":"),
                    React.createElement(Selector, { suffixDiv: true, type: "to", selectDisabled: isDyncGroupSend ? true : false, tabIndex: 31, items: isOneRcpt ? totalReceivers : normalReceivers, ref: sendSelectorRef, setKeyword: setKeywordSender, keyword: keywordSender, sendMailConflictConfig: sendMailConflictConfig, onKeyDown: event => {
                            if ((isMac && event.metaKey && event.key === 'Enter') || (!isMac && event.ctrlKey && event.key === 'Enter')) {
                                event.preventDefault();
                                debounceSendMail();
                            }
                            else if ((isMac && event.metaKey && event.key === 's') || (!isMac && event.ctrlKey && event.key === 's')) {
                                event.preventDefault();
                                debounceSaveDraft();
                            }
                        } })),
                btnBox),
            !isOneRcpt && !isDyncGroupSend && Boolean(showCc) && (React.createElement("div", { className: classnames([styles.wrapperCc]) },
                React.createElement("div", { "data-test-id": "mailinfo-selector-cc", className: classnames([styles.infoItem], {
                        [styles.infoItemWarning]: hasWrongCc,
                        [styles.flowColumn]: ccReceivers.length > 2,
                    }) },
                    React.createElement("div", { className: classnames([styles.receiverWrapper]) },
                        React.createElement("span", { className: classnames(styles.infoLabel, { [styles.executeLabel]: taskShow }) }, taskShow ? getIn18Text('CHAOSONG\uFF08GUANZHU') : getIn18Text('CHAOSONG')),
                        React.createElement("span", { className: styles.colonLabel }, ":"),
                        React.createElement(Selector, { type: "cc", items: ccReceivers, ref: ccSelectorRef, tabIndex: 32, keyword: keywordCC, setKeyword: setKeywordCC, sendMailConflictConfig: sendMailConflictConfig, onKeyDown: event => {
                                if ((isMac && event.metaKey && event.key === 'Enter') || (!isMac && event.ctrlKey && event.key === 'Enter')) {
                                    event.preventDefault();
                                    debounceSendMail();
                                }
                                else if ((isMac && event.metaKey && event.key === 's') || (!isMac && event.ctrlKey && event.key === 's')) {
                                    event.preventDefault();
                                    debounceSaveDraft();
                                }
                            } })),
                    React.createElement("div", { className: classnames(styles.btnBox) },
                        getPersonCount(ccReceivers, ccSelectorRef),
                        React.createElement("div", { className: styles.ccClose },
                            ccReceivers.length > 1 && React.createElement(NewPersonalGroup, { items: ccReceivers }),
                            React.createElement("span", { onClick: closeCC, className: styles.closeIcon },
                                React.createElement(IconCard, { className: "dark-invert", type: "close" }))))),
                React.createElement(FollowerCard, null))),
            !isOneRcpt && !isDyncGroupSend && Boolean(showBcc) && (React.createElement("div", { "data-test-id": "mailinfo-selector-bcc", className: classnames([styles.infoItem], {
                    [styles.infoItemWarning]: hasWrongBcc,
                    [styles.flowColumn]: bccReceivers.length > 2,
                }) },
                React.createElement("div", { className: classnames([styles.receiverWrapper]) },
                    React.createElement("span", { className: styles.infoLabel }, getIn18Text('MISONG')),
                    React.createElement("span", { className: styles.colonLabel }, ":"),
                    React.createElement(Selector, { type: "bcc", items: bccReceivers, ref: bccSelectorRef, tabIndex: 33, keyword: keywordBCC, setKeyword: setKeywordBCC, sendMailConflictConfig: sendMailConflictConfig })),
                React.createElement("div", { className: classnames(styles.btnBox) },
                    getPersonCount(bccReceivers, bccSelectorRef),
                    React.createElement("div", { className: styles.ccClose },
                        bccReceivers.length > 1 && React.createElement(NewPersonalGroup, { items: bccReceivers }),
                        React.createElement("span", { onClick: closeBCC, className: styles.closeIcon },
                            React.createElement(IconCard, { className: "dark-invert", type: "close" })))))),
            (process.env.BUILD_ISEDM || navigateVersion) && React.createElement(TimeZoneWriteMail, null),
            React.createElement("div", { className: classnames(styles.infoItem, styles.paddingRight16) },
                React.createElement("span", { className: styles.infoLabel }, taskShow ? getIn18Text('RENWUZHUTI') : getIn18Text('ZHUTI')),
                React.createElement("span", { className: styles.colonLabel }, ":"),
                React.createElement("div", { className: `ant-allow-dark ${styles.titleDesc}` }, renderSubjectContent()),
                process.env.BUILD_ISEDM && !isMailTemplate ? (React.createElement(AiPolishBtn, { dataTestId: "write-subject-ai", innerRef: aiPolishBtnRef, loading: subjectLoading, onClick: onClickAiPolish })) : null,
                process.env.BUILD_ISEDM && (React.createElement(InsertVariableBtn, { click: () => {
                        props.insertVariableClick && props.insertVariableClick();
                    } })),
                isMailTemplate || isOneRcpt || setEncrypt ? null : React.createElement(ConferenceBtn, null),
                visibleTaskOrPraise ? (React.createElement(React.Fragment, null,
                    React.createElement(TaskMailBtn, null),
                    comIsShowByAuth(ProductAuthorityFeature.PRAISE_EMAIL_WRITE_EMAIL_ENTRANCE_SHOW, React.createElement(PraiseMailBtn, null)))) : null),
            isMailTemplate ? null : React.createElement(Conference, Object.assign({}, props)),
            isMailTemplate ? null : comIsShowByAuth(ProductAuthorityFeature.PRAISE_EMAIL_WRITE_EMAIL_ENTRANCE_SHOW, React.createElement(PraiseMail, Object.assign({}, props))),
            isMailTemplate ? null : React.createElement(TaskMail, Object.assign({}, props)),
            !isMailTemplate && (React.createElement(Dropdown, { overlay: attMenu, trigger: ['contextMenu'] },
                React.createElement("div", { className: classnames(styles.attachmentsWrapper), style: !!attachmentsCount ? {} : { display: 'none' } },
                    React.createElement("div", { ref: attachmentAreaRef, className: classnames([styles.infoItem, attachmentFlod && styles.attachmentFlod]), style: { alignItems: 'flex-start' }, onClick: () => {
                        } },
                        React.createElement("span", { className: styles.infoLabel }, "\u9644\u4EF6"),
                        React.createElement("span", { className: styles.colonLabel }, ":"),
                        React.createElement("div", { className: styles.attachment, ref: attachmentsRef },
                            React.createElement(Attachment, { writeLetterProp: writeLetterProp }),
                            attachmentsHeight > 58 && (React.createElement("div", { className: styles.attachmentCount, onClick: () => {
                                    setAttachmentFlod(pre => !pre);
                                } },
                                React.createElement("span", null,
                                    "\u5171",
                                    attachmentsCount,
                                    "\u4E2A"),
                                React.createElement(IconCard, { type: attachmentFlod ? 'arrowDown' : 'arrowUp' })))))))),
            React.createElement("div", { style: { position: 'absolute', zIndex: -9999, top: -10000 } },
                React.createElement("div", { id: "drag-active-tags", style: { display: 'flex', justifyContent: 'space-evenly', alignItems: 'center' } }))),
        personalOrgModalVisible && (React.createElement(PersonalOrgModal, { defaultSelectedContact: defaultPersonalOrgSelect, modelZIndex: 101, onCancel: () => {
                setDefaultPersonalOrgSelect([]);
                setPersonalOrgModalVisible(false);
            }, onSure: () => {
                setDefaultPersonalOrgSelect([]);
                setPersonalOrgModalVisible(false);
            } })),
        process.env.BUILD_ISEDM && subjectHelperVisible && (React.createElement(EmailContentAssistantComponent, { isTheme: true, emailContentAssistantOpen: subjectHelperVisible, setEmailContentAssistantOpen: visible => {
                setSubjectHelperVisible(visible);
            }, insertContent: content => {
                if (content) {
                    modSubject(content);
                    setSubjectTemp(content);
                }
            } })),
        process.env.BUILD_ISEDM && !subjectHelperTipsClosed ? (React.createElement(LxPopover, { left: subjectHelperPos.left || 0, top: (subjectHelperPos.top || 0) + 44, visible: visibleSubjectHelper, resetStyle: subjectStyle, setVisible: () => {
                setVisibleSubjectHelper(false);
            } },
            React.createElement(SubjectHelper, { onClose: () => {
                    var _a;
                    const targetPos = (_a = aiPolishBtnRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
                    if (targetPos) {
                        const targetWidth = targetPos.width;
                        const scaleX = (targetWidth / Number(subjectStyle.width)).toFixed(3);
                        const scaleY = (targetPos.height / 76).toFixed(3);
                        setSubjectStyle({
                            width: subjectStyle.width,
                            left: targetPos.left,
                            top: targetPos.top,
                            transform: `scale(${scaleX}, ${scaleY})`,
                            opacity: 0.3,
                            transformOrigin: 'top left',
                            transition: 'all 0.4s ease',
                        });
                    }
                    setTimeout(() => {
                        setVisibleSubjectHelper(false);
                        dataStoreApi.putSync(SubjectHelperTips, 'true');
                        setSubjectHelperTipsClosed(true);
                    }, 400);
                }, loading: subjectLoading, onClickAiPolish: onClickAiPolish, onVisibleSubjectHelper: () => {
                    setVisibleSubjectHelper(false);
                    setSubjectHelperVisible(true);
                } }))) : null));
});
export default MailInfo;
